import React from "react";
const PageNotFound = () => {
  return (
    <div className="container navMarginMobile">
      <div className="row">
        <div className="col-12 mt-4 mb-4 text-center">
          <h1>404 Not Found</h1>
        </div>
      </div>
    </div>
  );
};
export default PageNotFound;
